// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-company-contacts-indexstyleGrid-container-cywiq{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-company-contacts-indexstyleGrid-grid-btffx{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-company-contacts-indexstyleGrid-col6-zigrf{grid-column:span 6}.pages-company-contacts-indexstyleGrid-col3-bpyyr{grid-column:span 3}.pages-company-contacts-indexstyleGrid-col4-btyxs{grid-column:span 4}.pages-company-contacts-indexstyleGrid-col9-byvww{grid-column:span 9}.pages-company-contacts-indexstyleGrid-col12-baryt{grid-column:span 12}.pages-company-contacts-indexstyleGrid-alignItemsStart-brgxy{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-company-contacts-indexstyleGrid-container-cywiq",
	"grid": "pages-company-contacts-indexstyleGrid-grid-btffx",
	"col6": "pages-company-contacts-indexstyleGrid-col6-zigrf",
	"col3": "pages-company-contacts-indexstyleGrid-col3-bpyyr",
	"col4": "pages-company-contacts-indexstyleGrid-col4-btyxs",
	"col9": "pages-company-contacts-indexstyleGrid-col9-byvww",
	"col12": "pages-company-contacts-indexstyleGrid-col12-baryt",
	"alignItemsStart": "pages-company-contacts-indexstyleGrid-alignItemsStart-brgxy"
};
module.exports = ___CSS_LOADER_EXPORT___;
